export default {
  header: 'Gravity',
  og: 'OG',
  sg: 'SG',
  fg: 'FG',
};
